import { useTranslation } from "react-i18next";

/** « Enregistrement expiré » (D-174), never a dead link or an error. */
export function RecordingExpired() {
  const { t } = useTranslation();
  return (
    <p className="ac-note" role="note">
      {t("academyHistory.recordingExpired")}
    </p>
  );
}
